import ApiConstant from "../ApiConstant/ApiConstant";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

let token = "";



const handleRequestError = (error) => {
    if (error.message.startsWith("Invalid origin")) {
      console.error(error.message);
      return error.message;
    }else if (!error.response) {
      // If it's a network error (no internet connection)
      console.error("Network Error:", error.message);
      return null;
    } else {
      throw error;
    }
  };

export const fetchToken = async() => {
  token = localStorage.getItem('authToken');
  if(token){
    let decodedToken = jwtDecode(token);

    if (decodedToken && decodedToken.exp * 1000 > Date.now()){

    } else {
      alert("Token has expired, Login again!");
      localStorage.removeItem('authToken');
    }
  }
}

export const addAnnouncement = async (announcement) => {
    fetchToken();
    try {
      const response = await axios.post(ApiConstant.baseApiAnnouncement, announcement, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const fetchAnnouncement = async () => {
    fetchToken();
    try {
      const response = await axios.get(ApiConstant.baseApiAnnouncement, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const fetchAnnouncementDetail = async (announcementId) => {
  fetchToken();
  try {
    const response = await axios.get(ApiConstant.baseApiAnnouncement + `/${announcementId}`, {
      headers: {
        Authorization : `Bearer ${token}`
      }
    });
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}

export const deleteAnnouncement = async (announcementId) => {
  fetchToken();
  try {
    const response = await axios.delete(ApiConstant.baseApiAnnouncement + `/${announcementId}`, {
      headers: {
        Authorization : `Bearer ${token}`
      }
    });
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}

export const editAnnouncement = async (announcementId, announcement) => {
  fetchToken();
  try {
    const response = await axios.put(ApiConstant.baseApiAnnouncement + `/${announcementId}`, announcement, {
      headers: {
        Authorization : `Bearer ${token}`
      }
    });
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}

export const fetchEarliestAnnouncement = async () => {
  // fetchToken();
  try {
    const response = await axios.get(ApiConstant.baseApiAnnouncement + '/retrieve-earliest');
      return response;
  } catch (error) {
      return handleRequestError(error);
  }
}